import React from 'react';

import { useScrollState } from '../../../../hooks/useScrollState/useScrollState';
import { IPrimaryHero } from '../../../../interfaces/hero';
import Header from '../../Globals/Header/Header';

import './PrimaryHero.scss';

const PrimaryHero = ({ title, description, color, bottomContent, sticky = true }: IPrimaryHero) => {
  const isScrolled = useScrollState(0);

  const heroHeight = isScrolled && sticky ? 144 : 431;

  return (
    <>
      <div
        className={`main-hero primary-hero ${color} ${isScrolled && sticky ? ' collapsed' : ''} ${
          sticky ? 'fixed-hero' : ''
        } `}
        style={{ height: heroHeight }}
      >
        <div className="content">
          <Header />
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
        <div className="bottom-content">{bottomContent}</div>
      </div>
      {sticky && <div style={{ height: heroHeight }} />}
    </>
  );
};

export default PrimaryHero;
